// constants
const SET_USER_STATUS = "SET_USER_STATUS";

// actions
export const setStatus = (payload) => ({
  type: SET_USER_STATUS,
  payload,
});

// reducer
const initialState = {
  status: 1
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_USER_STATUS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
